<script>
import { Switch } from 'element-ui';

export default {
  name: 'switch-small',
  mixins: [Switch],
  computed: {
    transform() {
      return this.checked ? `translate(${this.coreWidth - 16}px, 2px)` : 'translate(2px, 2px)';
    },
  },
};
</script>

<style lang="scss" scoped>
  .switch-small {
    height: 20px;
    line-height: 20px;
    position: relative;
    &:before {
      content: "";
      display: inline-block;
      vertical-align: middle;
      height: 100%;
    }
    .el-switch__core {
      height: 20px;
      .el-switch__button {
        width: 12px;
        height: 12px;
        top: 0; left: 0;
      }
    }
    .el-switch__label{
      height: 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ui/switch/switch-small.vue